import React, { useContext, useEffect, useMemo } from "react";

import { useIsFetching } from "@tanstack/react-query";

// App bridge
import { AppContext } from "./appContext.jsx";
import { useLocation, useNavigate } from "react-router-dom";
import { Provider, Loading } from "@shopify/app-bridge-react";

export default function AppBridgeProvider({ children }) {
  const isFetching = useIsFetching();

  // App bridge config
  const { apiKey, host } = useContext(AppContext);
  const appBridgeConfig = {
    apiKey,
    host,
    // forceRedirect: true, //appContext.isProduction,
  };

  // Router - with conditional check for context availability
  const navigate = useNavigate();
  const location = useLocation();
  
  // Only create router object if we have valid navigation context
  const router = useMemo(() => {
    if (!navigate || !location) return undefined;
    
    const history = { replace: (path) => navigate(path, { replace: true }) };
    return { location, history };
  }, [navigate, location]);

  return (
    <Provider config={appBridgeConfig} router={router}>
      {isFetching ? <Loading /> : null}
      {children}
    </Provider>
  );
}

